import { Box, useSlotRecipe } from '@chakra-ui/react';

import { CssTooltipProps } from '@app/components/atoms/css-tooltip';

export const CssTooltip = ({ content, children, tooltipProps, ...rest }: CssTooltipProps) => {
    const recipe = useSlotRecipe({ key: 'cssTooltip' });
    const styles = recipe({});

    return (
        <Box css={styles.root} {...rest}>
            {children}
            <Box
                className={'tooltip-content'}
                data-testid={'tooltip-content'}
                css={styles.content}
                {...tooltipProps}
            >
                {content}
            </Box>
        </Box>
    );
};
